import React from 'react';
import './Section.css';

const Section = () => {
    return (
        <>
            <div id="section-1619119305762" data-section-id="1619119305762">
                <section kjb-settings-id="sections_1619119305762_settings_background_color" className="section" data-reveal-event="" data-reveal-offset="" data-reveal-units="seconds">
                    <div className="sizer ">
                        <div className="container ">
                            <div className="row align-items-center justify-content-center">
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Section;
